import React, { useEffect } from "react";
import { Col, Form, Select } from "antd";
import get from "lodash/get";
import map from "lodash/map";
import find from "lodash/find";
import { useWatch } from "antd/es/form/Form";
import { analyzeBreaksInDuration, plannedProductionHandler } from "../../utilities/shift";

const ProductionComponentSelect = ({
  form,
  productionComArr,
  setCurrentProductionComp,
  name,
  setPcParts,
  cycle_time,
  filter
}) => {
  const components = useWatch("components", form);

  useEffect(() => {
    if (components) {
      const selectedProduction = find(productionComArr, [
        "id",
        get(components, [name, "component_uuid"]),
      ]);
      setPcParts((prev) => ({
        ...prev,
        [name]: get(selectedProduction, "parts"),
      }));
      setCurrentProductionComp((prev) => ({
        ...prev,
        [name]: selectedProduction,
      }));
    } else {
      setPcParts((prev) => ({
        ...prev,
        [name]: get(form.getFieldsValue(), ["components", name, "parts_full"]),
      }));
    }
  }, [components, name, productionComArr, form]);
  return (
    <Col md={6} xs={24}>
      <Form.Item
        name={[name, "component_uuid"]}
        label="Production Component"
        rules={[
          {
            required: true,
            message: "Please select a production component!",
          },
        ]}
      >
        <Select
          className="w-full"
          options={map(productionComArr, (production) => ({
            value: get(production, "id"),
            label: get(production, "name"),
          }))}
          placeholder="Production Component"
          size="small"
          onChange={(value) => {
            const selectedProduction = find(productionComArr, ["id", value]);
            setPcParts((prev) => ({
              ...prev,
              [name]: get(selectedProduction, "parts"),
            }));
            setCurrentProductionComp((prev) => ({
              ...prev,
              [name]: selectedProduction,
            }));
            if (get(selectedProduction, "is_default")) {
              form.setFieldValue(["components", name, "cycle_time"], cycle_time);
              form.setFieldValue(["components", name, "parts"], []);
              form.setFieldValue(["components", name, "parts_full"], []);
              form.setFieldValue(["components", name, "shot_weight"], 0);
            }
            else {
              const partsArr = map(get(selectedProduction, "parts"), (part) => get(part, "id"))
              const partsFullArr = map(get(selectedProduction, "parts"), (part) => {
                const plannedObj = plannedProductionHandler(get(selectedProduction, "type.value"),name, part, form)
                part.meta = {
                  ...get(part, 'meta'),
                  ...plannedObj
                };
                return part
              })
              form.setFieldValue(["components", name, "cycle_time"], get(selectedProduction, "parts.0.meta.cycle_time", 0));
              form.setFieldValue(["components", name, "parts"], partsArr);
              form.setFieldValue(["components", name, "parts_full"], partsFullArr);
              form.setFieldValue(["components", name, "shot_weight"],get(selectedProduction, "meta.shot_weight")?get(selectedProduction, "meta.shot_weight"):0);
            }
            
            const startVal = form.getFieldValue([
              "components",
              name,
              "start_time",
            ]);
            const endVal = form.getFieldValue(["components", name, "end_time"]);

            const duration = {
              start_time: startVal?.format ? startVal.format("HH:mm") : startVal,
              end_time: endVal?.format ? endVal.format("HH:mm") : endVal,
            };
            const { totalOverlappingBreakTimeMinutes } = analyzeBreaksInDuration(
              get(filter, "company.break_timings", []),
              duration
            );
            form.setFieldValue(
              ["components", name, "planned_down_time"],
              totalOverlappingBreakTimeMinutes
            );
          }}
        />
      </Form.Item>
    </Col>
  );
};

export default ProductionComponentSelect;
